import React from "react";
import "./Title.css";

const Title = () => {
  return (
    <div className="title_container">
      <div className="title_container__info">
        <h1>Hello World!</h1>
        <span className="title_container__description">
          I AM A SELF-MOTIVATED FRONT-END DEVELOPER WITH A PASSION FOR LEARNING.
        </span>
      </div>
    </div>
  );
};

export default Title;
